module.exports = __webpack_public_path__ + "img/order_banner_close.320be194.svg";